<template>
  <v-dialog :value="dialogCreateTask" max-width="950px" height="400px"  persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 65px;">
        <v-layout wrap justify-space-between align-center>
          <v-flex grow>
            <span class="headline">Automação para criar nova tarefa</span>
          </v-flex>
          <v-flex shrink>
            <v-btn icon fab @click="close()">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding-top:0px">
        <v-container fluid grid-list-md style="padding-top:0px">
          <v-layout row align-baseline wrap>
            <v-flex xs12><span>Criar uma nova tarefa com a descrição:</span></v-flex>
            <v-flex xs12>
              <v-form ref="form">
                <v-text-field id="task_id_text" maxlength="190" counter="190" :label="translate('table.tasks.field.id_text')" v-model="editedItem['id_text']" :rules="requiredRule('id_text')" validate-on-blur></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn v-if="!editMode" outline color="primary darken-2" @click="printDocument()"><v-icon>print</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'IMPRIMIR'}}</v-btn>
        <v-btn v-if="!editMode" outline color="primary darken-2" @click="pdfDocument()"><v-icon>picture_as_pdf</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'GERAR PDF'}}</v-btn> -->
        <v-btn outline color="primary darken-2" @click="createTask()" :loading="loading"><v-icon>add</v-icon>Criar</v-btn>
        <v-btn class="mx-0" @click.native="close()" :loading="loading">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
  import access from '../../mixin/access'
  import rules from '../../mixin/rules'
  import PFile from './PFile'
  
  export default {
    mixins: [access, rules],
    components: {PFile},
    data: () => ({
      values: {},
      indexIds: 0,
      loading: false,
      editedItem: {},
      defaultValue: {},
      config: [],
      // this. usado para usar dentro do watch
      this: null,
      basePath: process.env.API,
      formDataFiles: {},
      // idFile Armazena o ultimo id auxiliar dos arquivos, serve para poder saber de qual registro é o determinado arquivo, pois os registros de arquivos são adicionados antes de irem pro banco
      idFile: 0,
      // indexFile, usado para mostra que está no final dos arquivos, pois a medida que vai salvando vai adicionando 1, não pode usar o idFile para isso, pois caso tenha um arquivo muito grande e o usuário adicione outros arquivos durante o update, pode acabar tendo ids iguais para arquivos diferentes
      indexFile: 0
    }),
    methods: {
      openAutomationCreateTask () {
        this.values = this.$store.getters[`automationCreateTask/values`]
        // caso o index dos ids seja menor que a quantidade de ids, significa que possui automações de mensagem pendentes
        if (this.indexIds < this.values['tasktemplateAutomationIds'].length) this.getAutomationCreateTask()
      },
      getAutomationCreateTask () {
        this.loading = true
        this.config = []
        // Busca a lista de documentos personalizados da tarefa modelo da tarefa selecionada
        this.$http.get(`api/get_automation_create_task/${this.values['tasktemplateAutomationIds'][this.indexIds]}`).then((res) => {
          this.loading = false
          // Gerencia o editeditem para ficar compativel com a inclusão de tarefa
          this.editedItem = JSON.parse(JSON.stringify(res.body['tasktemplate']))
          
          if (this.editedItem.client_id) {
            this.editedItem.client_id = [this.editedItem.client_id]
          }
          this.editedItem.tasktemplate_id = this.editedItem.id
          this.editedItem.from_task_id = this.values['taskId']
          this.editedItem.top_id = null
          this.editedItem.identifier = null
        }, err => {
          console.log(err)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar a visualização da menssagem, reporte o erro.', color: 'error', dialog: true})
        })
      },
      createTask () {
        if (this.editedItem['id_text'] === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor inserir o titulo',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        // o saveFromAutomation chama o close
        this.$emit('saveFromAutomation', this.editedItem)
      },
      close () {
        this.indexIds++
        this.editedItem = {id_text: ""}
        this.loading = false
        this.$store.commit('loader/change_dialog', false)
        this.config = []
        // caso o usuário cancele ainda pode ter automações pendentes portanto verifica se possui alguma pendente
        if (this.indexIds < this.values['tasktemplateAutomationIds'].length) {
          this.$store.commit('automationCreateTask/change_values', {dialog: true})
          this.getAutomationCreateTask()
        } else {
          this.indexIds = 0
        }
        this.$store.commit('automationCreateTask/change_values', {dialog: false})
      }
    },
    computed: {
      dialogCreateTask () {
        // return true
        return this.$store.getters[`automationCreateTask/dialog`] || false
      }
    },
    watch: {
      // quando o dialogCreateTask é alterado chama a função openAutomationCreateTask
      dialogCreateTask: {
        handler: 'openAutomationCreateTask'
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PAutomationCreateTask.vue